export const lang = {
  nav: {
    fr: ["Accueil", "Qui somme-nous", "Louer", "Acheter", "Avocats", "Contact"],
    en: ["Home", "About us", "Rent", "Buy", "Lawyers", "Contact"]
  },
  home: {
    search: {
      fr: ["Louer", "Acheter", "Pays", "Ville", "Recherche"],
      en: ["Rent", "Buy", "Country", "City", "Search"]
    },
    result: {
      fr: ["Votre recherche", "Aucun résultat trouvé"],
      en: ["Your search", "No results found"]
    }
  },
  about: {
    fr: {title: "Qui sommes-nous", subtitle: "Bienvenue chez ebhousing,", content: "nous sommes une entreprise privée et indépendante, spécialisée dans l’immobilier en Gambie. Nos activités principales sont la vente des terrains, des villas et des appartements en location. Nous sommes propriétaires de toutes les bien listés sur notre site, sauf les appartements en location, ou nous collaborons avec d’autres partenaires. Je suis Ibrahima Diaby, autrement appelé par mon surnom (Eb), et je suis le fondateur d'ebhousing. Je vous encourage à découvrir nos magnifiques maisons et à prendre contact avec nous.", contact: "Service Client : +220 760 4439"},
    en: {title: "About ebhousing", subtitle: "Welcome to ebhousing,", content:  "we are a privately owned, independent company specializing in real estate in The Gambia. Our main activities are the sale of land, villas and rental apartments. We own all the properties listed on our site, except the rental apartments, where we collaborate with other partners. I'm Ibrahima Diaby, otherwise known by my nickname (Eb), and I'm the founder of ebhousing. I encourage you to discover our beautiful homes and get in touch with us.", contact: "Customer Service: +220 760 4439"}
  },
  rent: {
    title: {
      fr: "Location",
      en: "Rent"
    },
    price: {
      fr: "20 000€",
      en: "20 000$"
    },
    land: {
      fr: "Appartement",
      en: "Apartment"
    },
    view: {
      fr: "Voir le bien",
      en: "View the property"
    }
  },
  buy: {
    title: {
      fr: "Vente",
      en: "Buy"
    },
    price: {
      fr: "20 000€",
      en: "20 000$"
    },
    land: {
      fr: "Terrain",
      en: "Land"
    },
    view: {
      fr: "Voir le bien",
      en: "View the property"
    }
  },
  lawyer: {
    title: {
      fr: "Avocats",
      en: "Lawyers"
    }
  },
  contact: {
    title: {
      fr: ["Un bien vous interesse?", "On est disponible", "24h/24h", "pour vous répondre."],
      en: ["Interested in a property?", "We are available", "24/7", "to answer you."]
    },
    form: {
      fr: ["Nom", "Prénom", "Email", "Message", "Envoyer", "Ce champ est obligatoire"],
      en: ["Last name", "First name", "Email", "Message", "Send", "This field is required"]
    }
  }

}